module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/cn/CREW_BOOK_NATIONAL.b421ff41.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/cn/CREW_BOOK_NATIONAL.png
// module id = 1315
// module chunks = 16